// extracted by mini-css-extract-plugin
export default {"main":"SimpleLayout_main__reyCS","container":"SimpleLayout_container__0ImJ8"};